import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const interactiveImageTag = (props) => {
  const {
    interactiveImageTag: { x, y },
    image: { thumb_url },
    image,
    scale,
    callbacks: { selectImage },
  } = props

  const left = scale ? x * scale : scale
  const top = scale ? y * scale : scale

  return (
    <a className={styles.root} style={{ left, top }} onClick={() => selectImage(image)}>
      <div className={styles.preview} style={{ backgroundImage: `url(${thumb_url})` }} />
    </a>
  )
}

interactiveImageTag.propTypes = {
  interactiveImageTag: PropTypes.object.isRequired,
  image: PropTypes.object.isRequired,
  scale: PropTypes.number,
  callbacks: PropTypes.shape({
    selectImage: PropTypes.func.isRequired,
  }),
}

export default interactiveImageTag
